import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import './BottomTabBar.css'

const tabs = [
  {
    id: 'home',
    label: 'Home',
    path: '/',
    matchPaths: ['/', '/browse'],
    icon: () => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10.5V20h13v-9.5"/>
      </svg>
    ),
  },
  {
    id: 'camera',
    label: 'Camera',
    path: '/scan',
    matchPaths: ['/scan'],
    requiresAuth: true,
    icon: () => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 8h3l1.5-2.2h7L17 8h3a1 1 0 0 1 1 1v9.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z"/>
        <circle cx="12" cy="13.5" r="3.5"/>
      </svg>
    ),
  },
  {
    id: 'map',
    label: 'Map',
    path: '/map',
    matchPaths: ['/map'],
    icon: () => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="m9 4-6 2v14l6-2 6 2 6-2V4l-6 2-6-2Z"/><path d="M9 4v14"/><path d="M15 6v14"/>
      </svg>
    ),
  },
  {
    id: 'you',
    label: 'You',
    path: '/profile',
    matchPaths: ['/profile'],
    requiresAuth: true,
    icon: () => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="3.6"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/>
      </svg>
    ),
  },
]

export default function BottomTabBar() {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = useAuthStore((s) => s.token)

  // Hide on 3D viewer (when ?shopid= is present on root)
  if (pathname === '/' && searchParams.get('shopid')) return null
  // Hide on fullscreen intro page
  if (pathname === '/intro') return null
  // Hide across ThreeBuilder. The editor and the walkable viewer are
  // edge-to-edge tools with their own toolbars and their own back buttons; a
  // 220px navigation rail down the left is a quarter of the room you are trying
  // to look around.
  if (pathname.startsWith('/threebuilder')) return null

  const handleTabPress = (tab: typeof tabs[0]) => {
    if (tab.requiresAuth && !token) {
      navigate('/login')
      return
    }
    navigate(tab.path)
  }

  return (
    <nav className="bottom-tab-bar">
      <div className="bottom-tab-bar__brand">
        <img src="/logo.png" alt="Dukkan" className="bottom-tab-bar__logo" />
      </div>
      {tabs.map((tab) => {
        const active = tab.matchPaths.includes(pathname)
        const isCamera = tab.id === 'camera'
        return (
          <button
            key={tab.id}
            className={`tab-item${active ? ' tab-item--active' : ''}${isCamera ? ' tab-item--camera' : ''}`}
            onClick={() => handleTabPress(tab)}
          >
            {isCamera ? (
              <>
                <span className="tab-camera-pill">{tab.icon()}</span>
                <span className="tab-camera-icon">{tab.icon()}</span>
                <span className="tab-label">{tab.label}</span>
              </>
            ) : (
              <>
                {tab.icon()}
                <span className="tab-label">{tab.label}</span>
              </>
            )}
          </button>
        )
      })}
    </nav>
  )
}
